import React from 'react';
import { Field, Pill, inputCls, slug } from './atoms';
import { MOVE_TYPES, CHILDREN_COUNTS, VEHICLE_PLATES, VEHICLE_TYPES, BUDGETS } from './constants';

const Step4Household = ({ form, upd, setField }) => (
  <div data-testid="step-4">
    <div className="mb-5">
      <h1 className="text-xl sm:text-2xl font-light" data-testid="step4-headline">Tell us about your move.</h1>
      <p className="text-sm mt-1 text-[#5A6B73]">Who's coming, what's coming, what's the budget.</p>
    </div>

    <div className="space-y-4">
      <Field label="Move type" testId="field-move-type">
        <div className="grid grid-cols-2 gap-2">
          {MOVE_TYPES.map((m) => (
            <Pill key={m} active={form.move_type === m}
              onClick={() => setField('move_type', m)}
              testId={`onboarding-movetype-${slug(m)}`}>
              {m}
            </Pill>
          ))}
        </div>
      </Field>

      <Field label="Children coming?" testId="field-children">
        <div className="grid grid-cols-2 gap-2">
          <Pill active={form.children_coming === false}
            onClick={() => setField('children_coming', false)}
            testId="onboarding-children-no">No</Pill>
          <Pill active={form.children_coming === true}
            onClick={() => setField('children_coming', true)}
            testId="onboarding-children-yes">Yes</Pill>
        </div>
        {form.children_coming && (
          <div className="mt-3 space-y-2">
            <div className="grid grid-cols-4 gap-2">
              {CHILDREN_COUNTS.map((c) => (
                <Pill key={c} small active={String(form.children_count) === c.replace('+','')}
                  onClick={() => setField('children_count', Number(c.replace('+','')))}
                  testId={`onboarding-children-count-${c.replace('+','plus')}`}>
                  {c}
                </Pill>
              ))}
            </div>
            <input type="text" value={form.children_ages} onChange={upd('children_ages')}
              placeholder="Ages (e.g. 5, 8, 12)" className={inputCls(false)}
              data-testid="onboarding-children-ages" />
          </div>
        )}
      </Field>

      <Field label="Pets coming?" testId="field-pets">
        <div className="grid grid-cols-2 gap-2">
          <Pill active={form.pets_coming === false}
            onClick={() => setField('pets_coming', false)}
            testId="onboarding-pets-no">No</Pill>
          <Pill active={form.pets_coming === true}
            onClick={() => setField('pets_coming', true)}
            testId="onboarding-pets-yes">Yes</Pill>
        </div>
        {form.pets_coming && (
          <input type="text" value={form.pets_details} onChange={upd('pets_details')}
            placeholder="e.g. 1 dog and 2 cats" className={inputCls(false) + ' mt-2'}
            data-testid="onboarding-pets-details" />
        )}
      </Field>

      <Field label="Bringing a vehicle?" testId="field-vehicle">
        <div className="grid grid-cols-2 gap-2">
          <Pill active={form.vehicle_coming === false}
            onClick={() => setField('vehicle_coming', false)}
            testId="onboarding-vehicle-no">No</Pill>
          <Pill active={form.vehicle_coming === true}
            onClick={() => setField('vehicle_coming', true)}
            testId="onboarding-vehicle-yes">Yes</Pill>
        </div>
        {form.vehicle_coming && (
          <div className="mt-3 space-y-2">
            <div className="grid grid-cols-2 gap-2">
              {VEHICLE_PLATES.map((p) => (
                <Pill key={p} small active={form.vehicle_plates === p}
                  onClick={() => setField('vehicle_plates', p)}
                  testId={`onboarding-plates-${slug(p)}`}>
                  {p}
                </Pill>
              ))}
            </div>
            <div className="grid grid-cols-2 gap-2">
              {VEHICLE_TYPES.map((v) => (
                <Pill key={v} small active={form.vehicle_type === v}
                  onClick={() => setField('vehicle_type', v)}
                  testId={`onboarding-vehicle-type-${slug(v)}`}>
                  {v}
                </Pill>
              ))}
            </div>
          </div>
        )}
      </Field>

      <Field label="Estimated monthly budget (USD)" testId="field-budget">
        <div className="grid grid-cols-2 gap-2">
          {BUDGETS.map((b) => (
            <Pill key={b} active={form.monthly_budget_usd === b}
              onClick={() => setField('monthly_budget_usd', b)}
              testId={`onboarding-budget-${slug(b)}`}>
              {b}
            </Pill>
          ))}
        </div>
      </Field>
    </div>
  </div>
);

export default Step4Household;
